import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useClient } from "./Provider";
import { useNavigate } from "react-router-dom";
// components
import FormClient from "./FormClient";
import ModalBox from "../../ui/ModalBox";

const EditClient = () => {
  const navigate = useNavigate();
  let params = useParams();
  const id = params.id;
  const {
    state: { selected: client },
    fetchOne: fetchClient,
  } = useClient();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetchClient(id);
  }, [id, fetchClient]);
  const handleSuccess = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  return (
    <div>
      <div
        style={{
          fontSize: "14px",
          fontWeight: "600",
        }}
      >
        Edit Client
      </div>
      <div>
        <FormClient client={client} handleSuccess={handleSuccess} />
      </div>
      <ModalBox
        open={open}
        handleClose={handleClose}
        operation="edit"
        text="The update operation has been completed successfully.. You modified the client profile "
        name={client?.clientName}
      />
    </div>
  );
};

export default React.memo(EditClient);